"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelationshipType = void 0;
const isRelationshipType = (propType) => {
    return propType.relation !== undefined;
};
exports.isRelationshipType = isRelationshipType;
__exportStar(require("./MobileUIConfig"), exports);
__exportStar(require("./PagesConfig"), exports);
__exportStar(require("./ScheduleConfig"), exports);
__exportStar(require("./CommandDefinition"), exports);
__exportStar(require("./EventDefinition"), exports);
__exportStar(require("./WebUIConfig"), exports);
__exportStar(require("./config"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./Gen5ColorDefinition"), exports);
__exportStar(require("./CardDefinitions"), exports);
__exportStar(require("./TranslationsConfig"), exports);
//# sourceMappingURL=index.js.map